"use client"
import axiosInstance from '@/lib/axiosInstance';
import { setCookie } from '@/lib/cookies';
import { AxiosError } from 'axios';
import Link from 'next/link'
import { useRouter } from 'next/navigation';
import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { useOrgLogo } from '@/hooks/useOrgLogo';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
// var cookie = require('cookie');

// import { cookies } from 'next/headers'


type ErrorObject = {
    [key: string]: string
}


export default function Page() {
    const router = useRouter();
    const [message, setMessage] = useState<string | null>(null);
    const { logo: orgLogo, isLoading: logoLoading } = useOrgLogo();

    const [isSubmit, setIsSubmit] = useState<boolean>(false)
    // Function to get the expiration date for 6 months from now
    function getExpirationDate(months: number): string {
        const date = new Date();
        date.setMonth(date.getMonth() + months);
        return date.toUTCString();
    }
    
    useEffect(() => {
        // Access URL parameters using URLSearchParams
        const params = new URLSearchParams(window.location.search);
        const m = params.get('m');
        if (m) {
            setMessage(m);
            // Optionally, clear the query parameter from the URL after displaying the message
            router.push('/login'); // This will remove the query parameter
        }
    }, [router]);

    const [errors, setErrors] = useState<ErrorObject>({});
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [showPassword, setShowPassword] = useState(false);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsSubmit(true)

        let errorObject: ErrorObject = {};
        try {
            let response = await axiosInstance.post('api/users/signin', formData);
            let userType = response?.data?.data?.userType;
            let token = response?.data?.data?.token;

            // setCookie('authToken', token, 30); // 30 days expiration
            Cookies.set('authToken', token)
            Cookies.set('userType', userType)
            // document.cookie = `authToken=${token}; expires=${getExpirationDate(6)}; path=/; secure; HttpOnly`;
            if (userType == 'user') router.push('/dashboard')
            else router.push('/admin')

            // setErrors(errorObject);
        } catch (error) {
            if (error instanceof AxiosError) {

                let errorArray = error?.response?.data?.error
                // Convert the array of objects to a single object
                if (Array.isArray(errorArray))
                    errorObject = errorArray.reduce((acc: any, cur: any) => ({ ...acc, ...cur }), {});
                else if (typeof error?.response?.data === 'object')
                    errorObject = error.response.data;
                else
                    errorObject = { general: error?.response?.data };
                setErrors(errorObject);
            }

        } finally {
            setIsSubmit(false)
        }
    }

    return (
        <div>
            <div className="top_bar flex gap-10 items-center justify-between pr-3 md:pr-10 py-2 shadow-custom1">
                <div>
                    <Link href={"/"}>
                        {logoLoading ? (
                            <div className="md:max-w-[450px] h-12 flex items-center justify-center">
                                <svg 
                                    className="animate-spin h-8 w-8 text-gray-400" 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    fill="none" 
                                    viewBox="0 0 24 24"
                                >
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            </div>
                        ) : (
                            <img 
                                className="md:max-w-[450px]" 
                                src={orgLogo} 
                                alt="hart-college-logo"
                                onError={(e: any) => {
                                    e.target.src = "/images/hart-clg-new-logo.png";
                                }}
                            />
                        )}
                    </Link>
                </div>
                <nav className="flex md:gap-3 items-center flex-col md:flex-row">
                    <span className="underline text-xs md:text-sm text-nowrap">Don&apos;t have an account?</span>
                    <Link href={"/signup"} className="text-lg font-medium cursor-pointer">Signup</Link>
                </nav>
            </div>
            <div className="container border md:mt-14 rounded-md md:pt-10 pb-14">
                <h2 className="text-3xl font-playfair mt-5">Log in</h2>
                <hr className="my-3" />

                {message && <div className="p-4 text-sm text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400" role="alert">
                    Verification complete now you log in with your credentials
                </div>}

                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 py-5 gap-x-5 gap-y-4">
                        <div>
                            <label htmlFor="email">
                                Email:
                            </label>
                            <input className="border rounded-sm py-2 px-2 outline-none w-full block" type="email"
                                name="email"
                                id="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                            {errors?.email && <p className='text-red-500'>{errors.email}</p>}
                        </div>
                        <div>
                            <label htmlFor="password">
                                Password:
                            </label>
                            <div className="relative">
                                <input className="border rounded-sm py-2 px-2 pr-10 outline-none w-full block" type={showPassword ? "text" : "password"}
                                    name="password"
                                    id="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword((prev) => !prev)}
                                    className="absolute inset-y-0 right-2 flex items-center text-gray-500"
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>

                            {errors?.password && <p className='text-red-500'>{errors.password}</p>}

                        </div>
                    </div>
                    <div className="flex items-center mt-4">
                        <button
                            className="capitalize py-2 px-4 bg-[#43c6ac] hover:bg-[#60D3BD] text-white tracking-wider rounded"
                            disabled={isSubmit}
                        >
                            {isSubmit ? (
                                <div className="flex items-center justify-center">
                                    <svg
                                        className="animate-spin h-5 w-5 mr-2 text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        />
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 0 1 8-8v2a6 6 0 0 0-6 6h-2z"
                                        />
                                    </svg>
                                    {`Log In`}
                                </div>
                            ) : 'Log In'}
                        </button>

                        <Link
                            href="/forgot-password"
                            className="text-sm text-blue-600 hover:underline ml-2"
                        >
                            Forgot Password?
                        </Link>
                    </div>

                </form>


            </div>
        </div >
    )
}
